<template>
    <div class="dropdown" :style="{ display: 'flex' }">
        <btn
            :action="toggleOpen"
            :active="open"
            header
            :badge="countUnread"
            :icon="['fad', 'bell']"
        />
        <div class="notification-dropdown" v-if="!!open">
            <div class="notification-dropdown-header">
                <div class="btn-group">
                    <btn
                        type="link"
                        title="Segna come Lette"
                        size="small"
                        :action="markRead"
                        block
                        :disabled="!countUnread"
                    ></btn>
                </div>
            </div>
            <div class="notification-dropdown-content">
                <div class="notification-empty" v-if="!countUnread">
                    <div class="notification-empty--icon">
                        <font-awesome-icon
                            :icon="['fad', 'bells']"
                        ></font-awesome-icon>
                    </div>
                    <h4 class="notification-empty--title">
                        Nessuna Notifica Da Leggere!
                    </h4>
                </div>
                <div v-else>
                    <a
                        v-for="(item, key) in items"
                        :key="key"
                        class="notification-dropdown-item"
                        :class="'type-' + item.level_color"
                        :href="item.show_url"
                    >
                        <span class="notification-dropdown-item--icon">
                            <font-awesome-icon
                                :icon="typeIcon(item.level)"
                            ></font-awesome-icon>
                        </span>

                        <h6 class="notification-dropdown-item--title">
                            {{ item.title }}
                        </h6>

                        <p class="notification-dropdown-item--body">
                            {{ item.description }}
                        </p>
                        <div
                            class="notification-dropdown-item--close"
                            v-if="!item.read"
                        >
                            <btn
                                :action="() => markRead(item.toggle_read_url)"
                                type="primary"
                                label="Segna come Letta"
                                :icon="['fad', 'eye']"
                                size="small"
                                light
                                round
                                v-if="!item.read"
                            />
                        </div>
                    </a>
                </div>
            </div>
            <div class="notification-dropdown-footer">
                <div class="btn-group btn-block">
                    <btn
                        type="link"
                        title="Visualizza Tutte"
                        size="small"
                        :href="urlAll"
                        block
                    ></btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        open: false,
        items: [],
        countUnread: null
    }),
    props: {
        url: {
            type: String,
            default: null,
            required: true
        },
        urlCount: {
            type: String,
            default: null,
            required: true
        },
        urlReadAll: {
            type: String,
            default: null,
            required: true
        },
        urlAll: {
            type: String,
            default: null,
            required: true
        }
    },
    methods: {
        typeIcon: function(level) {
            switch (level) {
                case 0:
                    return ["fad", "exclamation-triangle"];
                    break;
                case 1:
                    return ["fad", "radiation"];
                    break;
                case 2:
                    return ["fad", "spider-black-widow"];
                    break;
                default:
                    return ["fad", "info-circle"];
                    break;
            }
        },
        toggleOpen: function() {
            this.open = !!this.open ? false : true;

            this.initAll();
        },
        makeRequest: function() {
            return this.$root.requestGet(this, this.url, this.processResponse);
        },
        processResponse: function(response) {
            if (response.data instanceof Array) this.items = response.data;
            else if (response instanceof Array) this.items = response;
        },
        makeRequestCount: function() {
            return this.$root.requestGet(
                this,
                this.urlCount,
                this.processResponseCount
            );
        },
        processResponseCount: function(response) {
            if (typeof response.data == "number")
                this.countUnread = response.data || null;
            else if (typeof response == "number")
                this.countUnread = response || null;
        },
        markRead: function(url = null) {
            if (!this.countUnread) return this.initAll();

            let httpUrl = this.urlReadAll;
            if (!!url) httpUrl = url;

            if (!httpUrl) return this.initAll();

            return this.$root.requestPatch(this, httpUrl, {}, function(
                response
            ) {
                this.initAll();
            });
        },
        initAll: function() {
            this.makeRequest();
            this.makeRequestCount();
        }
    },
    mounted: function() {
        let self = this;

        this.initAll();

        setInterval(function() {
            if (!self.open) self.makeRequestCount();
        }, 5000);
    }
};
</script>
